export default __webpack_public_path__ + "static/media/office2-afterA-480w.e25fc2a0.webp";